import * as React from "react";
import {
  StyleSheet,
  Image,
  View,
  Text,
  TouchableOpacity,
  Platform,
  Dimensions,
} from "react-native";
import { themePattern } from "../../constants/pattern";
import BtnCircle from "../buttons/BtnCircle";
import { useNavigation } from "@react-navigation/native";
import { FontAwesome } from "@expo/vector-icons";
import * as WebBrowser from "expo-web-browser";
import BtnRectangleHome from "../buttons/BtnRectangleHome";
import BtnSquareWhite from "../buttons/BtnSquareWhite";
const { width, height } = Dimensions.get("window");

const rota: any = "ModalNav";
const rotaHome: any = "DiscFront";
const rotaInstructions: any = "Instructions";
const rotaCredits: any = "Credits";
const rotaShared: any = "Shared";

const privacypolicy: any =
  "https://eic.ifsc.usp.br/app/privacypolicy/PoliticaPrivacidade_DiscoDeAminoacidos.pdf";

export default function NavDisplayDesktop() {
  const navigation = useNavigation();
  let logo = require("./../../assets/logo.png");

  // Função Referencia
  let openHelp = () => {
    navigation.navigate(rotaInstructions); // open drawer
  };
  let openCredits = () => {
    navigation.navigate(rotaCredits); // open drawer
  };
  let openShared = () => {
    navigation.navigate(rotaShared); // open drawer
  };

  let onPress = () => {
    navigation.navigate(rota); // open drawer
  };
  let openPrivacypolicy = () => {
    WebBrowser.openBrowserAsync(privacypolicy);
  };
  let openHome = () => {
    navigation.navigate(rotaHome); // open drawer
  };

  return (
    <View style={styles.bar}>
      <View style={styles.Opcoes}>
        <View style={styles.itemCenter}>
          <BtnRectangleHome
            icon={""}
            key={"iniciar"}
            name={"INCIAR"}
            onPress={() => openHome()}
          />
        </View>
      </View>
      <View style={styles.Opcoes}>
        <View style={styles.item}>
          <BtnSquareWhite
            icon={"question"}
            key={"ajuda"}
            name={""}
            onPress={() => openHelp()}
          />
        </View>
        <View style={styles.item}>
          <BtnSquareWhite
            icon={"group"}
            key={"creditos"}
            name={""}
            onPress={() => openCredits()}
          />
        </View>

        <View style={styles.item}>
          <BtnSquareWhite
            icon={"share-alt"}
            key={"compartilhar"}
            name={""}
            onPress={() => openShared()}
          />
        </View>
        <View style={styles.item}>
          <BtnSquareWhite
            icon={"ban"}
            key={"PRIVACIDADE"}
            name={""}
            onPress={() => openPrivacypolicy()}
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  bar: {
    flex: 1,
  },

  Opcoes: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: themePattern.mobile.retreat,
  },

  item: {
    flex: 1,
    width: 100,
  },

  itemCenter: {
    flex: 5,
    width: 100,
  },
});
